import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { formatToTimeZone } from 'date-fns-timezone';

import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import LastPageIcon from '@material-ui/icons/LastPage';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';

import LoadingOverlay from '../../common-components/LoadingOverlay';

//icons
import EditIcon from '@material-ui/icons/Edit';
import EmptyRowsMessage from '../../common-components/EmptyRowsMessage';

import * as usersReducers from '../reducer';
import * as usersSearchFormReducers from '../reducer/usersSearchForm';
import * as systemReducer from '../../system/reducer';

import * as userScreenReducer from '../reducer/userScreen';
import * as userScreenActions from '../action-mgr/userScreen';

import * as usersActions from '../action-mgr';
import * as strings from '../../helpers/strings';

import { timezone } from '../../helpers/constants';

const styles = {
  subClient: {
    backgroundColor: "#ceefff",
    display: "none",
    '& td:first-child': {
      paddingLeft: '75px'
    }
  }
}

class UsersTable extends Component {

  constructor() {
    super();

    this.handleRowSelect = this.handleRowSelect.bind(this);
    this.handleShowChild = this.handleShowChild.bind(this);

    this.state = {
      timezone: 'Africa/Bamako',
      value: '15'
    }
  }

  handleRowSelect = user => e => {
    const { history, selectUser, subClientSearch } = this.props;

    selectUser(user);

    if (user.hasChild) {
      subClientSearch(user.company).then(result => {
        history.push("/users/" + btoa(user.email));
      })
    } else if (user.role === "sub-system-user") {
      subClientSearch(user.company).then(result => {
        history.push("/users/" + btoa(user.email));
      })
    }
    else {
      history.push("/users/" + btoa(user.email));
    }

  }

  handleShowChild = user => e => {
    const { subClientSearch } = this.props;

    subClientSearch(user.company).then(result => {
      var dataAttribute = document.querySelectorAll(`[data-parentid="${user.id}"]`);
      for (var i = 0; i < dataAttribute.length; ++i) {
        dataAttribute[i].classList.toggle('showTableRowActive');
      }

    })

    e.currentTarget.classList.toggle("open")
  }

  handleStatusChange = event => {

    const timeZ = timezone.find(zone => zone.value === event.target.value);

    this.setState({
      value: event.target.value,
      timezone: timeZ.timezone
    })
  }

  timeformat(userTime) {
    var d = new Date(userTime.replace("+0000", 'Z'));
    return formatToTimeZone(d, "DD MMM, YYYY hh:mm A", { timeZone: this.state.timezone })
  }

  render() {
    const { totalRecord, classes, users, openedSnackBar, snackBarMessage, closeSnackBar, loggedInUser, userName, isSearching, status } = this.props;
    let counter = 0;

    return (
      <Paper >
        {(isSearching) && <LoadingOverlay />}
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={openedSnackBar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackBarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />

        <Table className="userInfoTable">
          <TableHead >
            <TableRow>
              <TableCell>{strings.lblName}</TableCell>
              <TableCell width={200}>{strings.lblRole}</TableCell>
              <TableCell>{strings.lblEmail}</TableCell>
              <TableCell>{strings.lblCompany}</TableCell>
              <TableCell>{strings.lblMaxSessionCompany}</TableCell>
              <TableCell>{strings.lblMaxSessionIndividual}</TableCell>
              <TableCell>{strings.lblActiveSession}</TableCell>
              <TableCell>{strings.lblLastLogin}<b>(GMT)</b>
                <Select
                  value={this.state.value}
                  onChange={this.handleStatusChange}
                  input={
                    <OutlinedInput
                      labelWidth={50}
                      name={strings.idSelectStatus}
                      id={strings.idSelectStatus}
                    />
                  }
                  style={{
                    marginLeft: '5px', maxWidth: '150px', fontSize: '10px'
                  }}
                >
                  {timezone.map(statusObj => <MenuItem
                    key={statusObj.value}
                    value={statusObj.value}
                    data-timezone={statusObj.timezone}
                    onClick={this.handleSelectTime}>{statusObj.name}</MenuItem>)}
                </Select> </TableCell>
              <TableCell>{strings.lblAction}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map(user => {
              counter++;
              counter = (counter === users.length) ? 0 : counter;

              return (
                <TableRow key={user.email} hover className={(user.parentId === null || user.parentId === '') ? '' : classes.subClient + ` child ${(userName !== "" && totalRecord > 0) ? 'showTableRowActive' : (status === 2) ? 'showTableRowActive' : ""}`} data-parentid={(user.parentId === null || user.parentId === '') ? '' : user.parentId}
                  style={{ display: (loggedInUser.role === "system-user" && (user.parentId === null || user.parentId === '') && user.role === "sub-system-user") ? "none" : '' }}
                >
                  <TableCell style={{ minWidth: '100px', paddingRight: '20px' }}>

                    {(user.hasChild && userName === "" && totalRecord > 0 && status !== 2) ?
                      <Button color="primary" className="toggleBtn " onClick={this.handleShowChild(user)}>
                        <LastPageIcon style={{ marginRight: "5px" }} />
                      </Button>
                      : ''}

                    {user.name}
                  </TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.company}</TableCell>
                  <TableCell>{(user.parentId === null || user.parentId === '') ? user.maxSession : ""}</TableCell>
                  <TableCell>{(user.role === "sub-system-user") ? user.maxSession : user.maxSessionIndividual}</TableCell>
                  <TableCell>{user.activeSession}</TableCell>
                  <TableCell>{user.lastLoginDatetime ? this.timeformat(user.lastLoginDatetime) : ""}</TableCell>
                  <TableCell>
                    {(loggedInUser.email !== user.email || loggedInUser.role === "admin") ? <EditIcon onClick={this.handleRowSelect(user)} style={{ cursor: 'pointer' }} /> : ""}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {!totalRecord && <EmptyRowsMessage message={strings.msgNoUserIsCreated} />}
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  users: usersReducers.getUsers(state),
  isSearching: usersReducers.getIsSearching(state),

  openedSnackBar: userScreenReducer.getOpenedSnackBar(state),
  snackBarMessage: userScreenReducer.getSnackBarMessage(state),
  totalRecord: usersSearchFormReducers.getPagination(state).totalRecord,

  status: usersSearchFormReducers.getStatus(state),
  userName: usersSearchFormReducers.getUserName(state),

  loggedInUser: systemReducer.getLoggedInUser(state)
});

const mapActionsToProps = {
  closeSnackBar: userScreenActions.closeSnackBar,
  search: usersActions.search,
  selectUser: usersActions.selectUser,
  subClientSearch: usersActions.subClientSearch,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(
    withRouter(UsersTable)
  )
)